import moment from "moment";
import thickElement from "../../../images/silver-icon/thick-element.png";
import { ApiClient } from "@topline/services/apiService";
import { AgGridService } from "@topline/services/agGridService";
import { IdSvrAuthService } from "../../auth/idSrvAuthService";
import { angularServicesNames } from "@topline/services/angularServicesNames";

(function (module) {
    "use strict";
    module.controller("budgetVersionDashboardCtrl", [
        IdSvrAuthService.componentName,
        AgGridService.componentName,
        angularServicesNames.$translate,
        angularServicesNames.$interval,
        ApiClient.componentName,
        budgetVersionDashboardCtrl
    ]);

    function budgetVersionDashboardCtrl(
        this: $TSFixMe,
        authService: IdSvrAuthService,
        agGridService: AgGridService,
        $translate: ng.translate.ITranslateService,
        $interval: ng.IIntervalService,
        apiClient: ApiClient
    ) {
        var $ctrl = this;

        $ctrl.reloadPageSize = (pageSize: $TSFixMe) => {
            if ($ctrl.gridApi) {
                $ctrl.gridApi.paginationSetPageSize(pageSize);
            }
        };

        authService
            .hasPermissionAsync("ExportBudgetVersionToML")
            .then(hasPermission => ($ctrl.canExportBudgetVersionToML = hasPermission));

        $ctrl.budgetVersionGridOptions = {
            columnDefs: [
                {
                    headerValueGetter: () => $translate.instant("BUDGET_VERSION.GRID.BUDGET_VERSION"),
                    children: [
                        {
                            headerValueGetter: () => $translate.instant("BUDGET_VERSION.GRID.NAME"),
                            field: "name",
                            filter: "agTextColumnFilter",
                            cellRenderer: (params: $TSFixMe) =>
                                params.data
                                    ? `<div class="ui-grid-cell-contents">
                                <a ui-sref="forecast.list.created({ budgetVersionUId : data.versionUId, budgetYear: data.budgetYear })" >${params.data.name}</a>
                            </div>`
                                    : null,
                            cellStyle: function (params: $TSFixMe) {
                                if (params.data.isEditable) {
                                    return {
                                        fontWeight: "bold"
                                    };
                                } else {
                                    return null;
                                }
                            }
                        },
                        {
                            headerValueGetter: () => $translate.instant("BUDGET_VERSION.GRID.BUDGET_YEAR"),
                            field: "budgetYear",
                            filter: "agSetColumnFilter"
                        },
                        {
                            headerValueGetter: () => $translate.instant("BUDGET_VERSION.GRID.CREATED_BY"),
                            field: "createdByInPandLFullName",
                            filter: "agSetColumnFilter"
                        },
                        {
                            headerValueGetter: () => $translate.instant("BUDGET_VERSION.GRID.STATUS"),
                            field: "status",
                            filter: "agSetColumnFilter",
                            cellRenderer: (params: $TSFixMe) =>
                                params.value ? $translate.instant(`BUDGET_VERSION.STATUS.${params.value}`) : "",
                            filterParams: {
                                values: ["NotEditable", "EditableForControlling", "Editable"],
                                newRowsAction: "keep",
                                cellRenderer: (params: $TSFixMe) =>
                                    params.value ? $translate.instant(`BUDGET_VERSION.STATUS.${params.value}`) : ""
                            }
                        },
                        {
                            headerValueGetter: () => $translate.instant("BUDGET_VERSION.GRID.MARKED_FOR_EXPORT"),
                            field: "markedForExport",
                            filter: "agSetColumnFilter",
                            cellRenderer: (params: $TSFixMe) => {
                                if (!params.data) return null;
                                return `<div class='ui-grid-cell-contents'>
                                    <span ng-show="data.markedForExport && data.isProcessing" class="glyphicon glyphicon-repeat normal-right-spinner"></span>
                                    <img ng-show="data.markedForExport && !data.isProcessing" src='${thickElement}' >
                                <div/>`;
                            }
                        },
                        {
                            field: "creationTimeInPandL",
                            headerValueGetter: () => $translate.instant("BUDGET_VERSION.GRID.CREATED_ON"),
                            valueFormatter: (params: $TSFixMe) => moment(params.value).format("YYYY-MM-DD H:mm:ss"),
                            filter: "agDateColumnFilter",
                            filterParams: {
                                browserDatePicker: true,
                                comparator: function (filterValue: $TSFixMe, cellValue: $TSFixMe) {
                                    const filterMoment = moment(filterValue);
                                    const cellMoment = moment(cellValue);
                                    if (filterMoment.isSame(cellMoment, "day")) {
                                        return 0;
                                    } else if (filterMoment.isAfter(cellMoment, "day")) {
                                        return -1;
                                    } else {
                                        return 1;
                                    }
                                }
                            },
                            sort: "desc"
                        }
                    ]
                },
                {
                    headerValueGetter: () => $translate.instant("BUDGET_VERSION.GRID.FORECAST"),
                    children: [
                        {
                            headerName: "",
                            headerTooltip: $translate.instant("BUDGET_VERSION.GRID.APPROVED"),
                            headerComponentParams: {
                                template: createHeaderTemplateWithIcon("glyphicon glyphicon-ok")
                            },
                            width: 60,
                            filter: false,
                            field: "forecastStatisticApprovedCount"
                        },
                        {
                            headerName: "",
                            headerTooltip: $translate.instant("BUDGET_VERSION.GRID.IN_CORRECTION"),
                            field: "forecastStatisticReturnedToCorrection",
                            headerComponentParams: {
                                template: createHeaderTemplateWithIcon("fas fa-undo")
                            },
                            width: 60,
                            filter: false
                        },
                        {
                            headerName: "",
                            headerTooltip: $translate.instant("BUDGET_VERSION.GRID.IN_APPROVAL"),
                            field: "forecastStatisticAwaitingBUMApprovalCount",
                            headerComponentParams: {
                                template: createHeaderTemplateWithIcon("glyphicon glyphicon-hourglass")
                            },
                            width: 60,
                            filter: false
                        }
                    ]
                },
                {
                    headerValueGetter: () => $translate.instant("BUDGET_VERSION.GRID.PRODUCT_CODE"),
                    children: [
                        {
                            headerName: "",
                            headerTooltip: $translate.instant("BUDGET_VERSION.GRID.APPROVED"),
                            headerComponentParams: {
                                template: createHeaderTemplateWithIcon("glyphicon glyphicon-ok")
                            },
                            width: 60,
                            filter: false,
                            field: "productCodeStatisticApprovedCount"
                        },
                        {
                            headerName: "",
                            headerTooltip: $translate.instant("BUDGET_VERSION.GRID.IN_CORRECTION"),
                            headerComponentParams: {
                                template: createHeaderTemplateWithIcon("fas fa-undo")
                            },
                            width: 60,
                            filter: false,
                            field: "productCodeStatisticReturnedToCorrection"
                        },
                        {
                            headerName: "",
                            headerTooltip: $translate.instant("BUDGET_VERSION.GRID.IN_APPROVAL"),
                            headerComponentParams: {
                                template: createHeaderTemplateWithIcon("glyphicon glyphicon-hourglass")
                            },
                            width: 60,
                            filter: false,
                            field: "productCodeStatisticAwaitingBUMApprovalCount"
                        }
                    ]
                },
                {
                    headerValueGetter: () => $translate.instant("ACTIONS"),
                    hide: !$ctrl.canExportBudgetVersionToML,
                    cellRenderer: () =>
                        `<div class="ui-grid-cell-contents">
                        <a class="remove-item" href="#" ng-if="!data.markedForExport" ng-click="$ctrl.exportBudgetVersion(data)" data-toggle="tooltip" data-placement="top" title="{{ 'TOOLTIP.EXPORT_TO_ML' | translate }}"><i class="glyphicon glyphicon-export"></i></a>
                        <a class="remove-item" href="#" ng-if="data.markedForExport" ng-click="$ctrl.removeBudgetVersionFromExport(data)" data-toggle="tooltip" data-placement="top" title="{{ 'TOOLTIP.REMOVE_FROM_EXPORT_TO_ML' | translate }}"><i class="glyphicon glyphicon-ban-circle"></i></a>
                    </div>`,
                    filter: false,
                    sortable: false,
                    suppressMenu: true,
                    width: 70
                }
            ],
            floatingFilter: true,
            angularCompileRows: true,
            defaultColDef: {
                filter: true,
                sortable: true,
                resizable: true
            },
            getRowNodeId: (data: $TSFixMe) => data.versionUId,
            animateRows: true,
            pagination: true,
            rowGroupPanelShow: "never",
            suppressMultiSort: true,
            paginationPageSize: 10,
            domLayout: "autoHeight",
            popupParent: document.getElementById("budgetVersionGrid"),
            localeTextFunc: agGridService.transalteFunc,
            suppressHorizontalScroll: true,
            onGridReady: (config: $TSFixMe) => {
                $ctrl.gridApi = config.api;
                config.api.sizeColumnsToFit();
                refreshGrid();
            },
            onGridSizeChanged: (config: $TSFixMe) => config.api.sizeColumnsToFit()
        };

        function createHeaderTemplateWithIcon(icon: $TSFixMe) {
            return `<div class="ag-cell-label-container" role="presentation">
                                      <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>
                                      <div ref="eLabel" class="ag-header-cell-label" role="presentation">
                                        <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>
                                        <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>
                                        <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>
                                        <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>
                                        <i class="${icon} margin-top-5"></i> <span ref="eText" class="ag-header-cell-text" role="columnheader"></span>
                                        <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>
                                      </div>
                                    </div>`;
        }

        $ctrl.exportBudgetVersion = (data: $TSFixMe) =>
            ($ctrl.serverOperation = apiClient.markBudgetVersionForExport(data.versionUId).then(() => refreshGrid()));
        $ctrl.removeBudgetVersionFromExport = (data: $TSFixMe) =>
            ($ctrl.serverOperation = apiClient.unmarkBudgetVersionForExport(data.versionUId).then(() => refreshGrid()));

        function refreshGrid() {
            $ctrl.gridApi.showLoadingOverlay();
            apiClient.getBudgetVersionDashboardData().then(items => {
                $ctrl.gridApi.setRowData(items);

                $ctrl.exportedBudgetVersionUId = _.chain(items)
                    .filter((f: $TSFixMe) => f.markedForExport)
                    .pluck("versionUId")
                    .first()
                    .value();
            });
        }

        $ctrl.checkExportingBudgetVersions = () => {
            apiClient.isExportingForecasts().then(isProcessing => {
                if ($ctrl.exportedBudgetVersionUId) {
                    const node = $ctrl.gridApi.getRowNode($ctrl.exportedBudgetVersionUId);
                    const data = node.data;
                    if (data.isProcessing != isProcessing) {
                        data.isProcessing = isProcessing;
                        node.setData(data);
                        $ctrl.gridApi.refreshClientSideRowModel();
                    }
                }
            });
        };

        $ctrl.$onInit = () => {
            $ctrl.intervalPromise = $interval($ctrl.checkExportingBudgetVersions, 5000);
        };

        $ctrl.$onDestroy = () => $interval.cancel($ctrl.intervalPromise);
    }
})(angular.module("topline.modules"));
